import { serviceIconsColors } from "@monorepo/components";
import { ServiceCategoryIdEnum } from "@monorepo/types";

export const getColor = (serviceId: ServiceCategoryIdEnum) => {
  switch (serviceId) {
    case ServiceCategoryIdEnum.ELECTRICITY: {
      return serviceIconsColors.electricity.color;
    }
    case ServiceCategoryIdEnum.GAS: {
      return serviceIconsColors.gas.color;
    }
    case ServiceCategoryIdEnum.WATER: {
      return serviceIconsColors.water.color;
    }
    case ServiceCategoryIdEnum.HEAT: {
      return serviceIconsColors.heat.color;
    }
    case ServiceCategoryIdEnum.HOUSE_CARE: {
      return serviceIconsColors.houseCare.color;
    }
    case ServiceCategoryIdEnum.TELECOMMUNICATIONS: {
      return serviceIconsColors.telecommunications.color;
    }
    case ServiceCategoryIdEnum.FINANCIAL_SERVICES: {
      return serviceIconsColors.financialServices.color;
    }
    case ServiceCategoryIdEnum.SECURITY: {
      return serviceIconsColors.security.color;
    }
    case ServiceCategoryIdEnum.EDUCATION: {
      return serviceIconsColors.education.color;
    }
    case ServiceCategoryIdEnum.FISHING: {
      return serviceIconsColors.fishing.color;
    }
    case ServiceCategoryIdEnum.INVOICES: {
      return serviceIconsColors.invoices.color;
    }
    case ServiceCategoryIdEnum.OTHER: {
      return serviceIconsColors.other.color;
    }
    case ServiceCategoryIdEnum.GARBAGE: {
      return serviceIconsColors.garbage.color;
    }
    default:
      return serviceIconsColors.other.color;
  }
};
